
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useBillStatusUpdate } from "./hooks/useBillStatusUpdate";
import { BillStatusForm } from "./components/BillStatusForm";
import { ApiResponseDisplay } from "./components/ApiResponseDisplay";
import { ApiTestingTips } from "./components/ApiTestingTips";

export function BillStatusUpdate() {
  const { loading, response, updateBillStatus } = useBillStatusUpdate();

  return (
    <Card className="mb-8">
      <CardHeader>
        <CardTitle>Update Bill Status API Test</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          <ApiTestingTips />
          <BillStatusForm onSubmit={updateBillStatus} loading={loading} />
          <ApiResponseDisplay response={response} />
        </div>
      </CardContent>
    </Card>
  );
}
